import React from 'react';
import { useParams } from 'react-router-dom';
import './BracesDetail.css';

const bracesList = [
  {
    id: 1,
    title: "Lingual Braces",
    date: "Aug 7, 2024",
    category: "Cosmetic Dentistry",
    content: `The desire to look good and  feel confident about one’s smile is what motivates us to get the braces treatment done!! Although the thought of getting those braces and wire fixed to the teeth is itself scary enough to hold many of us back from visiting the dentist. 
    As they say, where there is a will, there has to be a way. One of the many  alternatives which have come to the conventional braces are THE LINGUAL BRACES!! Although it does sound like something complicated, but it’s definitely not!!, Lingual means something which is behind. These braces are very similar to conventional metal braces.However, these braces  are placed on the inner surface of the teeth which means  behind the tooth, rather than  the front surfaces like the usual metal braces. They are specifically used in the  patients who are very conscious of their appearances and do not prefer getting conventional metal braces done.`,
   
    // image: "https://via.placeholder.com/300x200?text=Blog+Image+1",
  },
  {
    id: 2,
    title: "DAMON BRACES    ",
    date: "Jun 12, 2024",
    category: "Dental Tips",
    content: `Metal braces are known to all and has been there in practice since ages. They are  the oldest and most conventional form of braces that we all must have seen in at least one mouth we have come across. Metal braces are attached to the front surfaces of teeth and are most effective. The brackets and wire are both made of metal. They basically work by bringing desired movement of teeth in upper and lower jaws.What advantage do metal braces have?
    Affordable
    Effective but can take time to bring the desired tooth movements.
    Can be used in major and complicated cases as well.
    What are the disadvantages?
    Easily visible
    Need ligature (rubber) rings for attachment of wires.
    Difficult to control oral hygiene and with these rubber bands, treatment takes a longer time.`,
    // image: "https://via.placeholder.com/300x200?text=Blog+Image+2",
  },
  {
    id: 3,
    title: "The Impact of Cosmetic Dentistry on Overall Health",
    date: "Jun 12, 2024",
    category: "Cosmetic Dentistry",
    content: `SAY GOODBYE TO THE UNCOMFORTABLE AND MESSY BRACES  JOURNEY WITH DAMON BRACES SYSTEM!
    We all are well aware of the conventional metal braces with its metallic appearance and the elastic rubber bands which hold the wire with the braces. One major drawback of conventional braces was the time taken to get tooth alignment and the difficulty in maintaining oral hygiene with the rubber bands/elastic ties that bind the wires in place.
    
    Technology is evolving constantly, so is the field of dentistry. 
    
    A good substitute to conventional braces is the self ligating braces or DAMON CLEAR BRACES.Damon clear braces use a tie less slide mechanism which has minimal friction and allows the wire to move freely in braces hence working faster than the conventional braces.`,
    // image: "https://via.placeholder.com/300x200?text=Blog+Image+3",
  },
  {
    id: 4,
    title: "Ceramic Braces",
    date: "May 24, 2024",
    category: "Dental Tips",
    content: `Want to get braces done but loathing the metallic appearance of it!
    No need to worry!!
    In today’s time the technology  and recent advancements have brought up a solution for it as well which are ceramic or tooth colored braces. 
    These are just like metal braces but the advantage is that they are tooth colored and hence esthetically more pleasing.
They work in a similar way to metal braces and help in bringing the desired tooth movement required for tooth alignment `,
    // image: "https://via.placeholder.com/300x200?text=Blog+Image+4",
  },
  {
    id: 5,
    title: "Orthodontics/Braces in Mumbai",
    date: "Apr 8, 2024",
    category: "Cosmetic Dentistry",
    content: `Are you looking for the best dental treatment to correct your misaligned teeth and jaws?

    Dr. Ravneet Kaur provides braces treatment in Gurgaon, including Damon Self-Ligation (Fast Braces), Lingual Braces, Ceramic Braces, and Traditional Metal Braces to get a confident smile.
    
    Crooked teeth and teeth that do not fit together correctly are more challenging to clean, are more likely to be lost early due to tooth decay and periodontal disease, and create excessive pressure on the chewing muscles. It can cause headaches, TMJ syndrome, and neck, shoulder, and back pain. 
    
    Crooked or misaligned teeth can also detract from one's appearance. The treatment done by a qualified dentist like Dr. Ravneet Kaur, the one known for providing the best orthodontic treatment and also the best braces treatment in Gurgaon, can help one maintain a healthier mouth, a more attractive appearance, and teeth that are more likely to survive a lifetime. `,
    // image: "https://via.placeholder.com/300x200?text=Blog+Image+5",
  },
  {
    id: 6,
    title: "When Should You Visit the Dentist?",
    date: "Mar 30, 2024",
    category: "Dental Tips",
    content: `Regular dental visits are crucial for maintaining oral health, but many people are unsure how often they should go.  
The general rule is every six months for a routine cleaning and check-up. However, if you experience pain, sensitivity, or bleeding gums, 
schedule an appointment immediately. Certain groups, like smokers, pregnant women, and those with chronic illnesses, 
may require more frequent visits. Prevention is always better than cure, and timely check-ups can save you from major problems down the road.`,
    // image: "https://via.placeholder.com/300x200?text=Blog+Image+6",
  },
];

function BracesDetail() {
  const { id } = useParams();
  const braces = bracesList.find((b) => b.id === parseInt(id, 10));

  if (!braces) {
    return <div className="blog-not-found">Braces content not found</div>;
  }

  return (
    <div className="braces-detail">
      <h1 className="braces-detail-title">{braces.title}</h1>
      <p className="braces-meta">{braces.date} | {braces.category}</p>
      {/* <img src={braces.image} alt={braces.title} className="braces-detail-image" /> */}
      <p className="braces-detail-content">{braces.content}</p>
    </div>
  );
}

export default BracesDetail;
